import React, { useEffect, useState } from 'react';
import { ReactComponent as ChevronLeft } from '../../../assets/icons/chevron_left.svg';
import {
  AccordionContainer,
  AccordionContent,
  AccordionHeader,
  AccordionItem,
  Icon,
  RightSideContent,
  TitleContainer,
} from './Accordion.styles';
import { Text16Light, Text16Regular } from '../Text/Text.styles';

const Accordion = ({ items, contentHeight = 430, openLastItem = false }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = index => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    if (openLastItem && items.length) {
      setOpenIndex(items.length - 1);
    }
  }, [openLastItem, items]);

  return (
    <AccordionContainer>
      {items.map((item, index) => (
        <AccordionItem key={index} $isOpen={openIndex === index}>
          <AccordionHeader onClick={() => handleToggle(index)}>
            <TitleContainer>
              {openIndex !== index ? (
                <Text16Light>{item.title}</Text16Light>
              ) : (
                <Text16Regular>{item.title}</Text16Regular>
              )}
            </TitleContainer>

            <RightSideContent>{openIndex !== index && item.value}</RightSideContent>
            <Icon $isOpen={openIndex === index}>
              <ChevronLeft />
            </Icon>
          </AccordionHeader>
          <AccordionContent $contentHeight={contentHeight} $isOpen={openIndex === index}>
            {item.content}
          </AccordionContent>
        </AccordionItem>
      ))}
    </AccordionContainer>
  );
};

export default Accordion;
